const MenuItems = [
  {
    name: 'home',
    label: 'Home',
    location: '/home/dashboard',
    icon: 'icon-gauge',
    // No permissionArea = always visible
    items: [
      { name: 'dashboard', label: 'Dashboard', location: '/home/dashboard', icon: 'icon-gauge' },
      // This item has no permissionArea, so it's always visible
      { name: 'smpp', label: 'SMPP', location: '/home/smpp', icon: 'icon-shuffle' },
      // { name: 'system_log', label: 'System Log', location: '/home/system_log', icon: 'icon-flow-cascade' },
//      { name: 'active_calls', label: 'Active Calls', location: '/home/active_calls', icon: 'icon-phone' },
//      { name: 'registered_users', label: 'Registered Users', location: '/home/registered_users', icon: 'icon-user-add' },
    ],
  },
  {
    name: 'clients',
    label: 'Clients',
    location: '/clients/clients',
    icon: 'people',
    permissionArea: 'clients',
    items: [
      { name: 'clients', label: 'Clients', location: '/clients/clients', icon: 'icon-user', permissionArea: 'clients'},
      { name: 'companies', label: 'Companies', location: '/clients/companies', icon: 'icon-key', permissionArea: 'companies'},
    ],
  },
  {
    name: 'carriers',
    label: 'Interconnects',
    location: '/carriers/carriers',
    icon: 'router',
    permissionArea: 'carriers',
    items: [
      { name: 'carriers', label: 'Interconnects', location: '/carriers/carriers', icon: 'router', permissionArea: 'carriers'},
      { name: 'settings', label: 'Settings', location: '/carriers/settings/rewrite', icon: 'settings', permissionArea: 'carriers'},
    ],
  },
  {
    name: 'resellers',
    label: 'Resellers',
    location: '/resellers/resellers',
    icon: 'people',
    permissionArea: 'resellers',
    items: [
      { name: 'resellers', label: 'Resellers', location: '/resellers/resellers', icon: 'people', permissionArea: 'resellers'},
    ],
  },
  {
    name: 'rates',
    label: 'Rates',
    location: '/products/voice/rates',
    icon: 'receipt',
    permissionArea: 'rates',
    items: [
      { name: 'rates', label: 'Voice Rates', location: '/products/voice/rates', icon: 'receipt', feature: 'voice-wholesale', permissionArea: 'rates'},
      { name: 'smsrates', label: 'SMS Rates', location: '/products/sms/rates', icon: 'message', feature: 'sms-wholesale', permissionArea: 'rates'},
      { name: 'rate_profiles', label: 'Rate Profiles', location: '/products/rate_profiles', icon: 'list', permissionArea: 'rates'},
      { name: 'sms_master_codes', label: 'SMS Master Codes', location: '/products/sms_master_codes', icon: 'message', feature: 'sms-wholesale', permissionArea: 'rates'},
    ],
  },
  {
    name: 'contacts',
    label: 'Contacts',
    location: '/contacts/contacts',
    icon: 'people',
    permissionArea: 'contacts',
  },
  {
    name: 'ai_agents',
    label: 'AI Agents',
    location: '/ai/tasks',
    icon: 'robot',
    permissionArea: 'ai',
    items: [
      { name: 'tasks', label: 'Tasks', location: '/ai/tasks', icon: 'robot', permissionArea: 'ai'},
    ],
  },
  {
    name: 'automations',
    label: 'Automations',
    location: '/automations',
    icon: 'precision_manufacturing',
    permissionArea: 'automations',
  },
  {
    name: 'campaigns',
    label: 'Campaigns',
    location: '/campaigns/campaigns',
    icon: 'campaign',
    permissionArea: 'campaigns',
    items: [
      { name: 'campaigns', label: 'Campaigns', location: '/campaigns/campaigns', icon: 'campaign', permissionArea: 'campaigns'},
      { name: 'scheduler', label: 'Scheduler', location: '/campaigns/scheduler', icon: 'schedule', permissionArea: 'campaigns'},
    ],
  },
  {
    name: 'messages',
    label: 'Messages',
    location: '/messages/templates',
    icon: 'message',
    permissionArea: 'messages',
    items: [
      { name: 'templates', label: 'Templates', location: '/messages/templates', icon: 'message', permissionArea: 'messages'},
    ],
  },
  {
    name: 'numbers',
    label: 'Numbers',
    location: '/numbers/numbers',
    icon: 'numbers',
    permissionArea: 'numbers',
    items: [
      { name: 'numbers', label: 'Numbers', location: '/numbers/numbers', icon: 'numbers', permissionArea: 'numbers'},
    ],
  },
  {
    name: 'routing',
    label: 'Routing',
    location: '/routing/sms',
    icon: 'route',
    permissionArea: 'routing',
    feature: 'sms-wholesale',
    items: [
 //     { name: 'voice', label: 'Voice', location: '/routing/voice', icon: 'icon-phone'},
      { name: 'sms', label: 'SMS', location: '/routing/sms', icon: 'message', permissionArea: 'routing'}
    ],
  },
  {
    name: 'reports',
    label: 'Reports',
    location: '/reports',
    icon: 'bar_chart',
    permissionArea: 'reports',
    items: [
  //    { name: 'billing', label: 'Billing', location: '/reports/billing', icon: 'icon-suitcase'},
      { name: 'voice', label: 'Voice', location: '/reports/voice', icon: 'phone', feature: 'voice-wholesale', permissionArea: 'reports'},
      { name: 'sms', label: 'SMS', location: '/reports/sms', icon: 'message', feature: 'sms-wholesale', permissionArea: 'reports'},
      { name: 'invoices', label: 'Invoices', location: '/reports/invoices', icon: 'receipt', permissionArea: 'reports'},
      { name: 'payments', label: 'Payments', location: '/reports/payments', icon: 'receipt', permissionArea: 'reports'},
 //     { name: 'system_log', label: 'System Log', location: '/reports/system_log', icon: 'icon-flow-cascade'}
    ],
  },
  {
    name: 'admin',
    label: 'Admin',
    location: '/admin/users',
    icon: 'person',
    permissionArea: 'admin',
    items: [
      { name: 'users', label: 'Users', location: '/admin/users', icon: 'person'},
      { name: 'access', label: 'Access', location: '/admin/access', icon: 'key'},
    ],
  },
  {
    name: 'tools',
    label: 'Tools',
    location: '/tools/send_sms',
    icon: 'code',
    permissionArea: 'tools',
    items: [
      { name: 'send_sms', label: 'Send SMS', location: '/tools/send_sms', icon: 'key'},
    ],
  },
  {
    name: 'settings',
    label: 'Settings',
    location: '/settings/currencies',
    icon: 'settings',
    permissionArea: 'settings',
    items: [
      // { name: 'voice', label: 'My Web Account', location: '/settings/my_web_account', icon: 'icon-user'},
      // { name: 'options', label: 'Options', location: '/settings/options', icon: 'icon-tools'},
      { name: 'currencies', label: 'Currencies', location: '/settings/currencies', icon: 'attach_money', permissionArea: 'settings'},
      { name: 'payment_terms', label: 'Payment Terms', location: '/settings/payment_terms', icon: 'money', permissionArea: 'settings'},
      { name: 'invoice_templates', label: 'Invoice Templates', location: '/settings/invoice_templates', icon: 'receipt', permissionArea: 'settings'},
      { name: 'mail_accounts', label: 'Mail Accounts', location: '/settings/mail_accounts', icon: 'email', permissionArea: 'settings'},
      { name: 'tts_voices', label: 'TTS Voices', location: '/settings/tts_voices', icon: 'voice', permissionArea: 'settings'},
      // { name: 'nanpa_codes', label: 'Geo Codes', location: '/settings/nanpa_codes', icon: 'icon-map'}
    ],
  },
  {
    name: 'help',
    label: 'Help & Support',
    location: '/help',
    icon: 'help',
    // No permissionArea = always visible for all users
  },
  // Alternative way using the utility function:
  // alwaysVisible({
  //   name: 'help',
  //   label: 'Help & Support',
  //   location: '/help',
  //   icon: 'icon-help-circle',
  //   items: [
  //     { name: 'documentation', label: 'Documentation', location: '/help/docs', icon: 'icon-book'},
  //     { name: 'contact_support', label: 'Contact Support', location: '/help/contact', icon: 'icon-mail'},
  //   ],
  // }),
  {
    name: 'profile',
    label: 'My Profile',
    location: '/myprofile',
    icon: 'person',
    // No permissionArea = always visible for all users
  }
]

// Utility function to mark menu items as always visible (excluded from permission checks)
export const alwaysVisible = (menuItem) => {
  return {
    ...menuItem,
    permissionArea: null // Explicitly set to null to exclude from permission checks
  };
};

// Function to filter menu items based on user permissions
export const filterMenuItemsByPermissions = (menuItems, permissions) => {
  return menuItems.filter(menuItem => {
    // If no permissionArea is set, always show the menu item (excluded from permission check)
    if (!menuItem.permissionArea) {
      return true;
    }

    // Check if user has read permission for this menu area
    const hasPermission = permissions[menuItem.permissionArea]?.can_read;
    
    if (!hasPermission) {
      return false;
    }
    
    // Filter sub-items based on permissions
    if (menuItem.items) {
      const filteredItems = menuItem.items.filter(item => {
        // If no permissionArea is set, always show the sub-item
        if (!item.permissionArea) {
          return true;
        }
        return permissions[item.permissionArea]?.can_read;
      });
      
      // Only show menu item if it has at least one visible sub-item
      return filteredItems.length > 0;
    }
    
    return true;
  }).map(menuItem => {
    // Create a new object with filtered items
    if (menuItem.items) {
      return {
        ...menuItem,
        items: menuItem.items.filter(item => {
          // If no permissionArea is set, always show the sub-item
          if (!item.permissionArea) {
            return true;
          }
          return permissions[item.permissionArea]?.can_read;
        })
      };
    }
    return menuItem;
  });
};

export default MenuItems;